import * as ACTIONS from '../constants/hpsReplaceForm';
import * as service from '../utils/service';
import { formatPayload, applyModel } from '../utils/utils';
import { replaceModel } from '../utils/models';

export const changeStep = step => dispatch => dispatch({
  type: ACTIONS.HPS_REPLACE.CHANGE_STEP,
  payload: {
    step,
  },
});

export const verifyPatientInfo = (payload) => dispatch => dispatch({
  type: ACTIONS.HPS_REPLACE.VERIFY_PATIENT_INFO,
  payload: {
    ...payload,
  },
});

export const clearReplaceForm = () => dispatch => dispatch({
  type: ACTIONS.HPS_REPLACE.CLEAR,
});

export const submitFormInit = () => dispatch => dispatch({
  type: ACTIONS.SUBMIT_HPS_REPLACE_FORM.INIT,
  payload: {
    loading: true,
  },
});

export const submitFormError = error => dispatch => dispatch({
  type: ACTIONS.SUBMIT_HPS_REPLACE_FORM.ERROR,
  payload: {
    error,
    loading: false,
  },
});

export const submitFormSuccess = success => dispatch => dispatch({
  type: ACTIONS.SUBMIT_HPS_REPLACE_FORM.SUCCESS,
  payload: {
    success,
    loading: false,
  },
});

export const submitForm = () => (dispatch, getState) => {
  dispatch(submitFormInit());
  const { patientInformation } = getState().hpsReplaceForm;
  let payload = formatPayload(patientInformation);
  payload = {
    ...payload,
  };
  payload = applyModel({ payload, model: replaceModel });
  service.post({
    endpoint: '/ReplaceCard',
    payload,
  })
    .then((data) => dispatch(submitFormSuccess(data)))
    .catch(error => dispatch(submitFormError(error)));
};
